import { FrequencyOption, InfoCard, SenorityOption } from '../models/package.model';

export enum SeniorityLevel {
    junior = 1,
    senior = 2,
    supreme = 3
}
export enum SeniorityLevelString {
    junior = "1",
    senior = "2",
    supreme = "3",
    supremePlus = "4"
}

export const FREQUENCY_OPTIONS: Array<FrequencyOption> = [
    {
        text: 'texts.Packages_duration_months_option_12',
        value: '12',
    },
    {
        text: 'texts.Packages_duration_months_option_8',
        value: '8',
    },
    {
        text: 'texts.Packages_duration_months_option_6',
        value: '6',
    },
    {
        text: 'texts.Packages_duration_months_option_4',
        value: '4',
    }
];

export const SENIORITY_LEVELS: Array<SenorityOption> = [
    {
        text: 'texts.Packages_tutor_seniority_sp_level',
        level: SeniorityLevelString.supreme,
    },
    {
        text: 'texts.Packages_tutor_seniority_sr_level',
        level: SeniorityLevelString.senior,
    },
    {
        text: 'texts.Packages_tutor_seniority_jr_level',
        level: SeniorityLevelString.junior,
    }
]

export const INFO_CARDS: Array<InfoCard> = [
    {
        icon: "User_Heart",
        text: "texts.Packages_Info_Card_1"
    },
    {
        icon: "Calendar_Add",
        text: "texts.Packages_Info_Card_2"
    },
    {
        icon: "Verified_Check",
        text: "texts.Packages_Info_Card_3"
    },
    {
        icon: "Bill_List",
        text: "texts.Packages_Info_Card_4"
    }
];

export const SMALL_INFO_CARDS: Array<string> = [
    "texts.Packages_Info_Card_Small_1",
    "texts.Packages_Info_Card_Small_2",
    "texts.Packages_Info_Card_Small_3",
    "texts.Packages_Info_Card_Small_4"
]